import { useState } from 'react';
import { Box, Menu, MenuItem, Link, IconButton, useTheme } from '@mui/material';
import moreVertIconUrl from './Images/more-vert.svg';
import {
  exportMenuClassNames,
  exportMenuStyles,
  getExportMenuIconStyle,
} from './ExportMenuComponent.styles';

interface ExportMenuComponentProps {
  showPrint: boolean;
  showExport: boolean;
  onPrint: () => void;
  onExport: () => void;
}

export const ExportMenuComponent = ({
  showPrint,
  showExport,
  onPrint,
  onExport,
}: ExportMenuComponentProps) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: import('react').MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePrintClick = () => {
    onPrint();
    handleMenuClose();
  };

  const handleExportClick = () => {
    onExport();
    handleMenuClose();
  };

  // If both are true, show menu
  if (showPrint && showExport) {
    return (
      <>
        <IconButton
          aria-label="more"
          aria-controls={open ? 'action-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleMenuClick}
        >
          <Box
            component="span"
            className={exportMenuClassNames.moreIcon}
            sx={exportMenuStyles.moreIcon()}
            style={getExportMenuIconStyle(moreVertIconUrl)}
            aria-hidden="true"
          />
        </IconButton>
        <Menu
          id="action-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          slotProps={{
            list: {
              'aria-labelledby': 'action-menu-button',
            },
          }}
        >
          <MenuItem onClick={handleExportClick} sx={exportMenuStyles.menuItem(theme)}>Export</MenuItem>
          <MenuItem onClick={handlePrintClick} sx={exportMenuStyles.menuItem(theme)}>Print to PDF</MenuItem>
        </Menu>
      </>
    );
  }

  // If only showPrint is true, show Print link
  if (showPrint && !showExport) {
    return (
      <Link
        component="button"
        variant="body1"
        onClick={onPrint}
        sx={exportMenuStyles.link(theme)}
      >
        Print to PDF
      </Link>
    );
  }

  // If only showExport is true, show Export link
  if (showExport && !showPrint) {
    return (
      <Link
        component="button"
        variant="body1"
        onClick={onExport}
        sx={exportMenuStyles.link(theme)}
      >
        Export to CSV
      </Link>
    );
  }

  // If both are false, return null
  return null;
};

export default ExportMenuComponent;
